import React from 'react';
import cx from 'classnames';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';
import { ToolTipSvgIcon } from '../Assets/SvgIconComponent/CommonSvgIcon';


const ToolTipSection = (props) => {
    const { label, tooltipIconClass, tipPlacement = 'top' } = props;
    return (
        <OverlayTrigger placement={tipPlacement} overlay={<Popover id={`popover-positioned-${tipPlacement}`} className='customTooltipContainer'>{label}</Popover>}>
            <span className={cx('tooltipIconStyle', tooltipIconClass)}> <ToolTipSvgIcon /></span>
        </OverlayTrigger>
    )
}

export default ToolTipSection
